// src/AudioSpectrum/effects/sparklers.js
import { getHSLColor } from '../colorUtils.js';

export const drawSparklers = (ctx, frequencyData, width, height, sparklersRef) => {
  ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
  ctx.fillRect(0, 0, width, height);
  
  // 새로운 스파클러 생성
  for (let i = 0; i < frequencyData.length; i += 10) {
    const value = frequencyData[i];
    if (value > 80) {
      sparklersRef.current.push({
        x: (i / frequencyData.length) * width * 10,
        y: height - 50,
        vx: (Math.random() - 0.5) * 6,
        vy: -(Math.random() * 8 + 4),
        life: 1.0,
        decay: 0.02,
        size: (value / 255) * 2 + 0.5,
        color: getHSLColor(Math.random() * 60 + 30, 100, 80),
        sparkles: []
      });
    }
  }
  
  // 스파클러 업데이트
  sparklersRef.current = sparklersRef.current.filter(sparkler => {
    sparkler.x += sparkler.vx;
    sparkler.y += sparkler.vy;
    sparkler.vy += 0.2;
    sparkler.life -= sparkler.decay;
    
    // 메인 스파클러
    if (sparkler.life > 0) {
      ctx.globalAlpha = sparkler.life;
      ctx.fillStyle = sparkler.color;
      ctx.beginPath();
      ctx.arc(sparkler.x, sparkler.y, sparkler.size, 0, Math.PI * 2);
      ctx.fill();
      
      // 스파클 효과 생성
      if (Math.random() < 0.7) {
        sparkler.sparkles.push({
          x: sparkler.x + (Math.random() - 0.5) * 4,
          y: sparkler.y + (Math.random() - 0.5) * 4,
          life: 0.5,
          decay: 0.05,
          size: Math.random() * 1.5 + 0.5
        });
      }
      
      // 스파클 렌더링
      sparkler.sparkles = sparkler.sparkles.filter(spark => {
        spark.life -= spark.decay;
        if (spark.life > 0) {
          ctx.globalAlpha = spark.life;
          ctx.fillStyle = 'white';
          ctx.beginPath();
          ctx.arc(spark.x, spark.y, spark.size, 0, Math.PI * 2);
          ctx.fill();
          return true;
        }
        return false;
      });
      
      ctx.globalAlpha = 1.0;
      return true;
    }
    return false;
  });
};